module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_online_support-bf28bbcc9332e677cfcd2060b3e09bbb.jpg";